import {
  resolveFormMainSectionId,
  resolveMainSectionId,
  resolveQuestionId,
  resolveSubSectionId,
} from './create_sections_reorder_value_helpers.js';

function shouldSkipMainSectionDrop(ctx, target_main_section) {
  const target_id = resolveMainSectionId(target_main_section);
  const source_id = Number(ctx.dragged_main_section.main_section_id);
  return [!target_id, source_id === target_id].some(Boolean);
}

export async function handleMainSectionDrop(ctx, target_main_section, target_index) {
  if (shouldSkipMainSectionDrop(ctx, target_main_section)) {
    ctx.dragged_main_section = null;
    return;
  }

  const source_index = ctx.dragged_main_section.main_section_index;
  await ctx.reorder_main_sections_by_index(source_index, target_index);
  ctx.dragged_main_section = null;
}

function shouldSkipSubSectionDrop(ctx, main_section, target_sub_section) {
  const current_main_section_id = resolveFormMainSectionId(main_section);
  const target_section_id = resolveSubSectionId(target_sub_section);
  const source_main_section_id = Number(ctx.dragged_sub_section.main_section_id);
  const source_section_id = Number(ctx.dragged_sub_section.section_id);

  return [
    !current_main_section_id,
    source_main_section_id !== current_main_section_id,
    !target_section_id,
    source_section_id === target_section_id,
  ].some(Boolean);
}

export async function handleSubSectionDrop(ctx, main_section, target_sub_section, target_index) {
  if (shouldSkipSubSectionDrop(ctx, main_section, target_sub_section)) {
    ctx.dragged_sub_section = null;
    return;
  }

  const source_index = ctx.dragged_sub_section.sub_section_index;
  await ctx.reorder_sub_sections_by_index(main_section, source_index, target_index);
  ctx.dragged_sub_section = null;
}

function shouldSkipQuestionDrop(ctx, section, target_question, target_index) {
  const source_section_id = Number(ctx.dragged_question.section_id);
  const target_section_id = resolveSubSectionId(section);
  const target_question_id = resolveQuestionId(target_question);
  const is_same_question = ctx.dragged_question.question_index === target_index;

  return [
    !source_section_id,
    source_section_id !== target_section_id,
    !target_question_id,
    is_same_question,
  ].some(Boolean);
}

export async function handleQuestionDrop(ctx, section, target_question, target_index) {
  if (shouldSkipQuestionDrop(ctx, section, target_question, target_index)) {
    ctx.dragged_question = null;
    return;
  }

  const source_index = ctx.dragged_question.question_index;
  await ctx.reorder_section_questions(section, source_index, target_index);
  ctx.dragged_question = null;
}
